<template>
  <section class="section_toggle">
    <div class="inner">
      <div class="toggle_area">
        <button type="button" class="toggle_button" v-on:click="toggleClick">
          <h2 class="toggle_h2">투자유의사항</h2>
        </button>
        <SlideUpDown :active="active">
          <div class="toggle_content">
            <p class="toggle_text">
              투자자는 주식거래에 대하여 금융회사로부터 충분한 설명을 받을
              권리가 있으며, 투자전 상품설명서 등을 반드시 읽어보시기 바랍니다.
              ※이 금융투자상품은 예금자보호법에 따라 예금보험공사가 보호하지
              않습니다. ※금융상품은 자산가격 변동, 환율 변동 등에 따라
              투자원금의 손실(0~100%)이 발생할 수 있으며, 그 손실은 투자자에게
              귀속됩니다. ※미니스탁 해외주식 소수점 거래시 수수료는 매수
              0.25%(국내수수료 및 SEC fee*등 모든 비용 포함)이며, 기타 자세한
              사항은 홈페이지를 참조하시기 바랍니다.(*SEC fee 인상시에도 수수료
              변경없음) ※미니스탁 국내주식 거래시 뱅키스 온라인 거래 수수료는
              0.0140527%이며, 기타 자세한 사항은 홈페이지를 참조하시기 바랍니다.
              ※미니스탁 해외주식 소수점 거래시 매수 60% 우대환율, 매도 80%
              우대환율이 적용됩니다.(로이터 고시 매매 기준환율 +1% 스프레드
              기준) ※상환능력에 비해 대출금이 과도할 경우 개인신용평점이 하락할
              수 있으며, 이로 인해 금융거래와 관련된 불이익이 발생할 수
              있습니다. ※적정 담보비율 미달 시 기한 내 추가담보를 제공하지
              않으면 담보증권이 임의 처분될 수 있습니다.
            </p>
            <p class="toggle_text">
              한국투자증권 준법감시인 심사필
              제2023-1125호(2023.08.09~2024.08.08)
            </p>
            <p class="toggle_text">
              한국투자증권 본사 : 서울특별시 영등포구 의사당대로 88 (우)07321,
              고객센터 : 1544-5000
            </p>
          </div>
        </SlideUpDown>
      </div>
    </div>
  </section>
</template>

<script>
import SlideUpDown from "vue-slide-up-down";

export default {
  mounted() {
    this.$toggleArea = document.querySelector(".toggle_area");
  },
  components: {
    SlideUpDown,
  },
  data: () => ({
    active: false,
  }),
  methods: {
    toggleClick: function() {
      (this.active = !this.active), this.$toggleArea.classList.toggle("open");
    },
  },
};
</script>
